import { render, staticRenderFns } from "./checkDetails.vue?vue&type=template&id=617b2104&"
import script from "./checkDetails.vue?vue&type=script&lang=js&"
export * from "./checkDetails.vue?vue&type=script&lang=js&"
import style0 from "./checkDetails.vue?vue&type=style&index=0&id=617b2104&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('617b2104')) {
      api.createRecord('617b2104', component.options)
    } else {
      api.reload('617b2104', component.options)
    }
    module.hot.accept("./checkDetails.vue?vue&type=template&id=617b2104&", function () {
      api.rerender('617b2104', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/refund/dialog/checkDetails.vue"
export default component.exports